<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :modal-append-to-body="false"
    :show-close="false"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
             label-width="80px">
      <el-form-item label="类型">
        <el-select v-model="dataForm.type" placeholder="请选择类型" style="width: 100%">
          <el-option
            v-for="item in settingType"
            :key="item.type"
            :label="item.name"
            :value="item.type">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="键" prop="keyName">
        <el-input v-model="dataForm.keyName" placeholder="键"></el-input>
      </el-form-item>
      <el-form-item label="值" prop="value">
        <el-input v-model="dataForm.value" placeholder="值"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="note">
        <el-input v-model="dataForm.note" placeholder="备注"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      settingType: [],
      visible: false,
      dataForm: {
        id: 0,
        type: '',
        keyName: '',
        value: '',
        note: ''
      },
      dataRule: {
        type: [
          {required: true, message: '类型不能为空', trigger: 'blur'}
        ],
        keyName: [
          {required: true, message: '键不能为空', trigger: 'blur'}
        ],
        value: [
          {required: true, message: '值不能为空', trigger: 'blur'}
        ],
        note: [
          {required: true, message: '备注不能为空', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    init(id) {
      this.getOptionType()
      this.dataForm.id = id || null
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.$http({
            url: this.$http.adornUrl(`/configSetting/list`),
            method: 'get',
            params: this.$http.adornParams({
              id: this.dataForm.id
            })
          }).then(({data}) => {
            if (data && data.code === 200) {
              this.dataForm = data.data.rows[0]
            }
          })
        }
      })
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl(`/configSetting/${!this.dataForm.id ? 'save' : 'update'}`),
            method: 'post',
            data: this.$http.adornData({
              'id': this.dataForm.id || undefined,
              'type': this.dataForm.type,
              'keyName': this.dataForm.keyName,
              'value': this.dataForm.value,
              'note': this.dataForm.note
            })
          }).then(({data}) => {
            if (data && data.code === 200) {
              this.visible = false
              this.$emit('refreshDataList')
              this.$message({
                message: data.msg,
                type: 'success',
                duration: 1000,
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    },
    //获取类型
    getOptionType() {
      this.$http({
        url: this.$http.adornUrl("/configSetting/type/list"),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.settingType = data.data.rows
        }
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/parameters/configsetting-add-or-update.vue